/* esm.sh - lib0@0.2.117/webcrypto */
var t=crypto.subtle,o=crypto.getRandomValues.bind(crypto);export{o as getRandomValues,t as subtle};
//# sourceMappingURL=webcrypto.mjs.map